/**
  This file exists so that Volto can properly override the Footer.
  Technically, we can put all the component code here, but for
  the sake of organization keep it with the other components
  and just import is here instead.
 */

import Footer from '../../../../../components/Footer/Footer';

export default Footer;
